import { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { categories } from "@/mocks/categories";

export default function CategoryDropdown() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClick(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    }
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

  return (
    <div className="relative" ref={ref}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="flex w-full items-center justify-between gap-3 whitespace-nowrap rounded-full border border-background-200 bg-white px-5 py-3 text-sm font-semibold text-foreground-900 shadow-sm transition-colors hover:bg-background-100 sm:w-80"
      >
        <span className="flex items-center gap-2">
          <span className="flex h-5 w-5 items-center justify-center text-primary-600">
            <i className="ri-grid-line text-base"></i>
          </span>
          {t("dropdownLabel")}
        </span>
        <span className="flex h-4 w-4 items-center justify-center">
          {open ? <i className="ri-arrow-up-s-line text-base"></i> : <i className="ri-arrow-down-s-line text-base"></i>}
        </span>
      </button>

      {open && (
        <div className="absolute left-0 right-0 z-30 mt-2 max-h-80 overflow-y-auto rounded-lg border border-background-200 bg-white py-1 shadow-sm sm:w-80">
          {categories.map((c) => (
            <a
              key={c.key}
              href={c.url}
              target="_blank"
              rel="noopener nofollow"
              onClick={() => setOpen(false)}
              className="flex items-center justify-between whitespace-nowrap px-4 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:bg-primary-50 hover:text-primary-700"
            >
              <span>{t(`categories.${c.key}`)}</span>
              <span className="flex h-4 w-4 items-center justify-center text-foreground-400">
                <i className="ri-external-link-line text-sm"></i>
              </span>
            </a>
          ))}
        </div>
      )}
    </div>
  );
}